import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { GetRegistryViewQuery } from 'src/config/generated/graphql'

import { RegistryFormValues } from './types'

dayjs.extend(utc)

const DEFAULT_HERO_IMAGE = 'assets/img/default-registry.png'

export const buildInitialValues = (
  registry?: GetRegistryViewQuery['RegistryView'][0],
  accountId?: string
) => {
  return registry
    ? {
        ClosesOn: registry.ClosesOn
          ? dayjs.utc(registry.ClosesOn).toDate()
          : null,
        Description: registry.Description || '',
        Hero: registry.Hero!,
        HeroFile: [],
        IsHidden: registry.IsHidden!,
        IsClosed: registry.IsClosed,
        IsCampaign: registry.IsCampaign,
        Name: registry.Name!,
        RegionId: registry.RegionId || 'choose_for_me',
        AccountId: accountId || registry.Account?.Id,
        Summary: registry.Summary,
        Uri: registry.Uri
      }
    : {
        ClosesOn: null,
        Description: '',
        Hero: DEFAULT_HERO_IMAGE,
        HeroFile: [],
        IsHidden: false,
        IsClosed: false,
        IsCampaign: false,
        Name: '',
        RegionId: 'choose_for_me',
        AccountId: accountId,
        Summary: '',
        Uri: ''
      }
}

export const transformFormData = (
  values: RegistryFormValues,
  isStaff: boolean,
  isUpdate: boolean = false
) => {
  const formValues = {
    ...values,
    ClosesOn: values.ClosesOn ? dayjs(values.ClosesOn).toISOString() : null,
    // Only include IsClosed if a staff member is updating. Users cannot update this field
    IsClosed: isStaff ? values.IsClosed : undefined,
    IsCampaign: isStaff ? values.IsCampaign : undefined,
    Uri: isStaff ? values.Uri : undefined,
    RegionId: values.RegionId === 'choose_for_me' ? null : values.RegionId
  }

  if (isUpdate) {
    delete formValues.AccountId
  }

  delete formValues.HeroFile
  return formValues
}
